var render, staticRenderFns
import script from "./detailAdd.vue?vue&type=script&lang=js"
export * from "./detailAdd.vue?vue&type=script&lang=js"
import style0 from "./detailAdd.vue?vue&type=style&index=0&id=24c866ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c866ac",
  null
  
)

export default component.exports